import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { ChangePasswordModel } from '../../model/auth/change-password.model';
import { AuthService } from '../../services/auth/auth.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { UtilitiesService } from '../../services/utilities/utilities.service';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrl: './password-change.component.scss',
})
export class PasswordChangeComponent {
  @Input() public emailFromCorporateAdmin: string = null;

  public isCurrentPasswordVisible = false;
  public isNewPasswordVisible = false;
  public isConfirmPasswordVisible = false;
  public isCorporate: boolean = false;

  public changePasswordModel: ChangePasswordModel = new ChangePasswordModel();
  public confirmPassword: string = '';

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService
  ) {}

  public ngOnInit(): void {
    this.isCorporate = this.localStorageService.getIsCorporateAdmin();
    console.log(this.isCorporate);
    if (this.emailFromCorporateAdmin) {
      this.changePasswordModel.email = this.emailFromCorporateAdmin;
    } else {
      this.changePasswordModel.email =
        this.localStorageService.getSessionUser()?.email;
    }
  }

  public toggleCurrentPasswordVisibility = () => {
    this.isCurrentPasswordVisible = !this.isCurrentPasswordVisible;
  };

  public toggleNewPasswordVisibility = () => {
    this.isNewPasswordVisible = !this.isNewPasswordVisible;
  };

  public toggleConfirmPasswordVisibility = () => {
    this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
  };

  public passwordComparison = () => this.changePasswordModel.new_password;

  public onSubmit(): void {
    const { isValid } = ValidationEngine.validateGroup('validationGrp');
    if (isValid) {
      if (this.emailFromCorporateAdmin) {
        this.changePasswordModel.email = this.emailFromCorporateAdmin;
      }
      this.authService.changePassword(this.changePasswordModel).subscribe({
        next: (result) => {
          this.onSuccess(result);
        },
        error: (err) => {
          this.onError(err);
        },
      });
    }
  }

  private onSuccess(res: any) {
    this.clearField();
    this.authService.logout();
    this.authService.shouldShowToast = true;
    this.router.navigateByUrl('/auth/login');
    this.utilitiesService.showSwalWithToast(
      'Password Successfully Changed!',
      'Your password has been updated. You can now use your new password to log in.',
      'success',
      true,
      8000
    );
  }

  private onError(error: any) {
    this.utilitiesService.showSwalWithToast(
      'ERROR',
      error?.error?.message,
      'error',
      true,
      8000
    );
  }

  private clearField() {
    ValidationEngine.resetGroup('validationGrp');
    this.changePasswordModel.email = '';
  }
}
